import React from "react";
import {
  Box,
  Dialog,
  DialogTitle,
  Divider,
  IconButton,
  Paper,
  Tooltip,
  useTheme,
} from "@mui/material";
import LoadingSpinner from "components/LoadingSpinner";

import formatDate from "utils/formatDate";
import PreviousAlertFilter from "components/pages/transmissions/modal/detail/previous_alert/PreviousAlertFilter";
import { capitalizeFirstLetterOfEachWord } from "utils/string";

import { useDispatch, useSelector } from "react-redux";
import {
  setPreviousReport,
  setSelectedAlert,
  toggleModal,
} from "app/store/transmission/slice/transmissionSlice";
import { useGetPreviousAlertsQuery } from "app/store/transmission/api/transmissionDetailApi";

import { DEFAULT_DATE_FORMAT } from "static/date";
import { REPORT_SEVERITY_MAP } from "static/constants";
import { Close } from "@mui/icons-material";

const PreviousAlert = () => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const { isPreviousAlertModal, reportId, alertFilter, dateFilter } =
    useSelector((state) => state.transmission);
  const {
    isLoading,
    isFetching,
    data: previousAlerts,
  } = useGetPreviousAlertsQuery({
    reportId,
    alert: alertFilter,
    date: dateFilter,
    isPreviousAlert: isPreviousAlertModal,
  });

  const handleAlert = async (value) => {
    dispatch(toggleModal({ type: "pdfModal", value: true }));
    dispatch(
      setPreviousReport({
        id: value?.reportId,
        date: value?.updated_at,
        isLegacy: false,
        billingCode: value?.billing_code,
      })
    );
    dispatch(setSelectedAlert(value));
  };

  const handleClose = () => {
    dispatch(toggleModal({ type: "previousAlert", value: false }));
  };

  return (
    <>
      <div
        className="report-note-header__right"
        data-action="previous-alert-label"
        onClick={() => {
          dispatch(toggleModal({ type: "previousAlert", value: true }));
        }}
      >
        View Previous Alerts
      </div>

      <Dialog open={isPreviousAlertModal} onClose={handleClose} maxWidth="lg">
        <DialogTitle>
          <Box
            className="dialog-header"
            style={{ backgroundColor: theme.palette.background.paper }}
          >
            <div className="dialog-header__title">View Previous Alerts</div>

            <Tooltip title="Close" placement="bottom">
              <IconButton onClick={handleClose}>
                <Close />
              </IconButton>
            </Tooltip>
          </Box>
        </DialogTitle>
        <Divider />
        <Paper className="report-note-popover-wrapper">
          <PreviousAlertFilter isLoading={isLoading || isFetching} />

          <div className="report-note-popover-content">
            {isLoading || isFetching ? (
              <div style={{ padding: "50px 0", textAlign: "center" }}>
                <LoadingSpinner color="secondary" />
              </div>
            ) : previousAlerts?.every(
                (item) => item?.content?.length === 0 || !item.title
              ) ? (
              <div className="report-alerts-empty">
                <div className="report-alerts-empty__title">
                  No alerts found
                </div>
                <div className="report-alerts-empty__content">
                  <div>
                    There are no previous alerts with the above criteria.
                  </div>
                  <div>Please try searching with different filters.</div>
                </div>
              </div>
            ) : (
              previousAlerts &&
              previousAlerts?.map((note) => {
                return note?.content?.length > 0 && note.title ? (
                  <div className="report-note-popover-item" key={note.id}>
                    <div className="report-note-popover-item__title">
                      {capitalizeFirstLetterOfEachWord(note.title)} :
                    </div>
                    <div className="report-note-popover-item__content">
                      {note.content?.map((content) => {
                        return (
                          <div
                            className="report-note-popover-item__content-item"
                            key={content.id}
                            style={{
                              backgroundColor:
                                REPORT_SEVERITY_MAP[content.alert],
                            }}
                          >
                            <div
                              className="report-note-popover-item__content-item-description"
                              style={{
                                color:
                                  theme.palette.type === "dark"
                                    ? "#212121"
                                    : "#FDEDED",
                                cursor: content.pageNumber
                                  ? "pointer"
                                  : "default",
                                textDecoration: content.pageNumber
                                  ? "underline"
                                  : "none",
                              }}
                              onClick={(e) => {
                                e.preventDefault();
                                if (content.pageNumber) {
                                  handleAlert({
                                    ...content,
                                    title: note?.title,
                                  });
                                }
                              }}
                            >
                              {content.description}
                            </div>
                            <div
                              className="report-note-popover-item__content-item-date"
                              style={{
                                color:
                                  theme.palette.type === "dark"
                                    ? "#212121"
                                    : "#FDEDED",
                              }}
                            >
                              {formatDate(
                                content.updated_at,
                                DEFAULT_DATE_FORMAT
                              )}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                ) : null;
              })
            )}
          </div>
        </Paper>
      </Dialog>
    </>
  );
};

export default PreviousAlert;
